export  enum ApproveStatusType {
    Approved = 1,
    YettobeVerified = 2,
    Rejected =3,
    Clarification = 4
}


